import Constants from 'expo-constants';

import { PaymentProcessor, usePaymentMethodStore } from '..';

export default function useBuildPaymentProcessor() {
  const userAccountsData = usePaymentMethodStore(s => s.userAccountsData);

  const buildRegion = Constants.expoConfig?.extra?.eas?.buildRegion;
  let processor = userAccountsData?.userAccounts?.paymentProcessor;

  // Safeguard: If processor is undefined or doesn't have matching config, determine from available configs
  const orbitalConfig = Constants.expoConfig?.extra?.eas?.[buildRegion]?.orbital;
  const worldpayConfig = Constants.expoConfig?.extra?.eas?.[buildRegion]?.worldpay;

  if (!processor) {
    // Backend didn't provide a processor (userAccountsData may be empty if LaunchDarkly flag is off)
    // Default to whichever config is available
    if (orbitalConfig) {
      processor = PaymentProcessor.ORBITAL;
    } else if (worldpayConfig) {
      processor = PaymentProcessor.WORLDPAY;
    }
  }

  return processor;
}
